<template>
  <div class="data" :ref="id"></div>
</template>

<script>
  export default {
    props: ['chartData', 'id', 'name'],
    data() {
      return {
        myChart: undefined,
        resizeHandler: null
      }
    },
    created() {
      this.debounceResize = _.debounce(this.resize, 200)
      this.resizeHandler = _ => {
        this.debounceResize()
      }
      window.addEventListener('resize', this.resizeHandler)
    },
    mounted() {
      this.initEchart()
    },
    methods: {
      resize() {
        try {
          this.myChart.resize()
        } catch (e) {
          console.log(e)
        }
      },
      initEchart() {
        if (this.myChart) this.myChart.dispose()
        let dom = this.$refs[this.id]
        let myChart = this.$echarts.init(dom)
        this.myChart = myChart
        this.myChart.setOption(this.getOption())
      },
      getOption() {
        let option
        option = {
          tooltip: {
            trigger: 'axis',
            backgroundColor: '#012c56',
            borderWidth: 0,
            formatter: function(params) {
              var res = '<div style="color:#fff;" ><p>' + params[0].name + ' </p></div>'
              var isFirstGreater = false
              if (params.length >= 2) {
                // 注意：这里需要根据你的数据类型（数字还是字符串）进行转换，防止字符串比较
                var val1 = Number(params[0].data)
                var val2 = Number(params[1].data)
                isFirstGreater = val1 > val2
              }
              for (let i = 0; i < params.length; i++) {
                let color = params[i].color
                var bgStyle = color
                // 判断是否为 ECharts 的 LinearGradient 对象
                // ECharts 渐变对象通常包含 colorStops 属性
                if (color && typeof color === 'object' && color.colorStops) {
                  // 手动拼接 CSS 渐变字符串
                  // 注意：这里简化处理，假设是垂直渐变 (x, y, x2, y2) -> (0, 0, 0, 1)
                  // 如果你的渐变方向不同，可能需要根据 color.x, color.y 等动态调整
                  var stops = color.colorStops
                    .map(function(stop) {
                      return stop.color + ' ' + stop.offset * 100 + '%'
                    })
                    .join(', ')

                  // 生成 CSS linear-gradient 语法
                  bgStyle = 'linear-gradient(180deg, ' + stops + ')'
                }

                let imgHtml = ''
                if (i === 0 && isFirstGreater) {
                  // 使用 require 引入本地图片（如果是 Vue CLI / Webpack 环境）
                  // 注意：在 formatter 字符串中不能直接写 require，需要在函数外部定义好路径
                  imgHtml = `<img src="${require('./up.png')}" style="width:11px;height:14px;vertical-align:middle;margin-left:5px;" />`
                }
                res += `<div style="color: #fff;font-size: 14px; padding:0 12px;line-height: 24px">
									<span style="display:inline-block;margin-right:5px;border-radius:100%;width:8px;height:8px;background:${bgStyle};"></span>
									${params[i].seriesName}
									${params[i].data}
									${imgHtml}
								</div>`
              }
              return res // 经过这么一加工，最终返回出去并渲染，最终就出现了我们所看的效果
            },
            axisPointer: {
              type: 'shadow',
              shadowStyle: {
                shadowColor: '#012c56'
              }
            }
          },
          legend: {
            show: true,
            bottom: '2%',
            left: 'center',
            itemWidth: 20,
            itemHeight: 5, // 修改icon图形大小
            itemGap: 24,
            icon: 'rect', // 设置图例图标为线条样式
            textStyle: {
              fontSize: 12,
              color: '#f3f7ff',
              padding: [0, 0, 0, 0] // 修改文字和图标距离
            }
          },
          grid: {
            top: '5%',
            left: '5%',
            right: '4%',
            bottom: '10%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              boundaryGap: true,
              data: this.chartData.xAxis,
              axisLabel: {
                color: '#b3ccff',
                fontSize: 14,
                rotate: 45
              },
              axisLine: {
                lineStyle: {
                  color: 'rgba(158, 198, 255, 0.4)'
                }
              },
              axisTick: {
                show: false
              }
            }
          ],
          yAxis: [
            {
              show: true,
              type: 'value',
              min: 0,
              splitLine: {
                show: true, //是否显示网格
                lineStyle: {
                  type: 'solid',
                  color: 'rgba(158, 198, 255, 0.4)'
                }
              },
              axisLabel: {
                color: '#b3ccff',
                fontSize: 12
              },
              axisLine: {
                show: false
              }
            }
          ],
          series: [
            {
              name: this.name[0],
              type: 'bar',
              showBackground: false,
              barWidth: '5px',
              barGap: '50%',
              itemStyle: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: '#4DF2FF'
                  },
                  {
                    offset: 1,
                    color: '#2196FF'
                  }
                ])
              },
              data: this.chartData.yAxis.data1
            },
            {
              name: this.name[1],
              type: 'bar',
              showBackground: false,
              barGap: '50%',
              barWidth: '5px',
              itemStyle: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: '#FDD783'
                  },
                  {
                    offset: 1,
                    color: '#EFFF97'
                  }
                ])
              },
              data: this.chartData.yAxis.data2
            }
          ]
        }
        return option
      },
      refresh() {
        this.myChart.clear()
        this.myChart.setOption(this.getOption())
      }
    },
    watch: {
      chartData: {
        handler() {
          this.$nextTick(() => {
            this.refresh()
          })
        },
        deep: true
        // immediate: true,
      }
    },
    destroyed() {
      if (this.myChart) this.myChart.dispose()
      if (this.resizeHandler) {
        window.removeEventListener('resize', this.resizeHandler)
      }
      if (this.debounceResize && this.debounceResize.cancel) {
        this.debounceResize.cancel()
      }
    }
  }
</script>

<style lang="less" scoped>
  .data {
    width: 100%;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/pumpMonitor/leftTwo/lineChart.vue